import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import {
	compose,
	withState,
	withPropsOnChange,
	lifecycle,
	getContext,
	renderNothing
} from 'recompose';

import CustomOverlay, { initialize } from './customOverlay';
import { GOOGLE, MAP } from './constants';

export const initializeOverlay = ({
	[MAP]: map, [GOOGLE]: google, appendToMap, overlay, setOverlay, position, children,
	offsetY, disableIdleEvent, className, gesturesDisabled, idleDisabled, animationDelay
}) => {
	if (map && google && !overlay) {
		initialize(google);

		const newOverlay = new CustomOverlay({
			idleDisabled,
			appendToMap,
			className,
			gesturesDisabled,
			position: new google.maps.LatLng(position),
			component: children,
			map,
			offsetY,
			disableIdleEvent,
			google,
			animationDelay
		});

		setOverlay(newOverlay);
	}
};

export const enhance = compose(
	getContext({
		[MAP]: PropTypes.any,
		[GOOGLE]: PropTypes.any,
		store: PropTypes.object
	}),
	// wrap any children in a provider
	withPropsOnChange(
		['children', 'store'],
		({ children, store }) => ({
			children: (
				<Provider store={store}>
					{children}
				</Provider>
			)
		})
	),
	withState('overlay', 'setOverlay', null),
	withPropsOnChange(['zIndex', 'overlay'], ({ zIndex, overlay }) => {
		if (overlay) {
			overlay.setZIndex(zIndex);
		}
	}),
	withPropsOnChange(['children'], ({ children, overlay }) => {
		if (overlay) {
			overlay.updateComponent(children);
		}
	}),
	lifecycle({
		componentDidMount() {
			initializeOverlay(this.props);
		},
		componentDidUpdate() {
			initializeOverlay(this.props);
		},
		componentWillUnmount() {
			if (this.props.overlay) {
				this.props.overlay.setMap(null);
			}
		}
	}),
	renderNothing
);

export default enhance();
